<div mat-dialog-title>
  <p>Your email <strong>{{email}}</strong> could not be found.</p>
  <p>Please be sure to enter the email address that you received your application invitation with.</p>
  <p>Contact {{settings.boardAbbreviation}} at {{loginSupportContact}}.</p>
</div>
<p mat-dialog-actions>
  <button class="auto" mat-button type="submit" [mat-dialog-close] color="primary">OK</button>
</p>
